import React, { useState, useEffect } from 'react';
import { Select, Card, Typography, Space, Button } from 'antd';
import { FilterOutlined, ClearOutlined } from '@ant-design/icons';
import { extractOrgsFromData } from '../utils/dataFilter';

const { Option } = Select;
const { Text } = Typography;

interface OrgFilterProps {
  data: any;
  onFilterChange: (selectedOrgs: string[]) => void;
  selectedOrgs: string[];
}

const OrgFilter: React.FC<OrgFilterProps> = ({ data, onFilterChange, selectedOrgs }) => {
  const [availableOrgs, setAvailableOrgs] = useState<string[]>([]);

  useEffect(() => {
    // 使用統一的數據提取函數，支持多種數據格式
    const orgs = extractOrgsFromData(data);
    setAvailableOrgs(orgs);
  }, [data]);

  const handleSelectChange = (values: string[]) => {
    onFilterChange(values);
  };

  const handleClearAll = () => {
    onFilterChange([]);
  };

  const handleSelectAll = () => {
    onFilterChange(availableOrgs);
  };

  if (availableOrgs.length === 0) {
    return null;
  }

  return (
    <Card 
      size="small" 
      style={{ marginBottom: 16 }}
      title={
        <Space>
          <FilterOutlined />
          <Text strong>組織篩選</Text>
        </Space>
      }
      extra={
        <Space>
          <Button 
            size="small" 
            onClick={handleSelectAll}
            disabled={selectedOrgs.length === availableOrgs.length}
          >
            全選
          </Button>
          <Button 
            size="small" 
            icon={<ClearOutlined />} 
            onClick={handleClearAll}
            disabled={selectedOrgs.length === 0}
          >
            清除
          </Button>
        </Space>
      }
    >
      <Select
        mode="multiple"
        style={{ width: '100%' }}
        placeholder="選擇要顯示的組織（留空顯示全部）"
        value={selectedOrgs}
        onChange={handleSelectChange}
        showSearch
        filterOption={(input, option) =>
          (option?.children as unknown as string)?.toLowerCase().includes(input.toLowerCase())
        }
        maxTagCount="responsive"
      >
        {availableOrgs.map(org => (
          <Option key={org} value={org}>
            {org}
          </Option>
        ))}
      </Select>
      {selectedOrgs.length > 0 && (
        <div style={{ marginTop: 8 }}>
          <Text type="secondary">
            已選擇 {selectedOrgs.length} 個組織，共 {availableOrgs.length} 個可用組織
          </Text>
        </div>
      )}
    </Card>
  );
};

export default OrgFilter; 